import { Stack } from '../stack/index.ts'
import { LoadingSpinner } from './loading-spinner.tsx'

export const LoadingCenter = () => (
  <Stack height="full">
    <LoadingSpinner className="text-primary-blue h-12 w-12 m-auto" />
  </Stack>
)
